/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import { Button } from 'react-bootstrap';
import { CellRendererButton, Cell } from 'components/gifts-table/TableList';
import { PriceCell, TotalAmount } from 'components/gifts-table/Cells';
import { CurrencyFormat } from 'components/Helpers';
import { PROJECT_BASENAME } from 'constants/env';
import styles from './styles.module.scss';

const handleRowClick = (gift) => {
    !isMobile && history.push(`/regalos-recibidos/${gift.id}/details`);
  };

export const columns = ({ onWelcomeClick, onClickDetail, onHandleRowClick } = {}) => [
  {
    label: 'Imagen',
    //field: '<img src={product_image} />',
    align: 'center',
    renderer: (rowData) => {
      return (
        rowData.product_image ?
        <center>
        <img
          src={rowData.product_image} // Asegúrate de que product_image contenga la URL de la imagen
          alt= {rowData.product_image}
          style={{ width: '50px', height: '50px' }} // Puedes ajustar el tamaño de la imagen según tus necesidades
        /></center>
        : <center> </center>
      );
    },
  },
  {
    label: 'Regalo:',
    field: 'product_description',
    align: 'left',
    //showDetail: true,
  },
  {
    label: 'De parte de:',
    field: 'whoGaveTheGift',
    align: 'center',
    //showDetail: true,
  },
  /*{
    label: 'CANTIDAD',
    field: 'totalAmount',
    align: 'center',
    smoothScroll: true,
    weight: 'bold',
    renderer: (props) => <TotalAmount {...props} />,
  },*/
  {
    label: 'Mensaje de felicitación',
    field: 'congratulationMessage',
    align: 'left',
    longField: true,
    //showDetail: true,
    //onClickDetail,
  },
  {
    label: 'Total',
    field: 'price',
    align: 'center',
    //showDetail: true,
    renderer: (props) => <PriceCell {...props} />,
  },

  {
    label: 'Agradecimiento',
    field: 'status',
    align: 'center',
    //weight: 'bold',
    noRenderer: true,
    renderer: (props) =>
      ![3, 5].includes(props.orderStatusId) || !props.hasEmail ? 
        <td className="text-center">
          <b>&nbsp;</b>
        </td>
      : props.showThanks && props.status === false ? (
        <CellRendererButton {...props} onClick={onHandleRowClick}>
          Agradecer
        </CellRendererButton>
      ) : (
        <td className="text-center">
          <b>{props.status === true ? 'Enviado' : 'No enviado'}</b>
        </td>
      ),
  },
  {
    label: ' ',
    showDetailLink: true,
  },
];

export const mobileColumns = ({ onWelcomeClick, onClickDetail } = {}) => [
  {
    label: 'REGALO',
    field: 'status',
    align: 'center',
    weight: 'bold',
    noRenderer: true,
    renderer: (props = {}, column, item = {}) => {
      const { isBody, stopParentPropagation, showThanks } = props;
      const {
        whoGaveTheGift = '',
        congratulationMessage = '',
        status = '',
        price = 0
      } = item;

      const handleClick = (eventToExecute) => {
        if (stopParentPropagation) stopParentPropagation();
        if (eventToExecute) eventToExecute();
      };

      return (
        <>
          {isBody ? (
            <div
              className={`${styles.giftTableCard} d-flex flex-column align-items-center my-4`}
            >
              <div className={`${styles.header} d-flex justify-content-around`}>
                <div className="text-center d-flex flex-column justify-content-center align-items-center">
                  <p>{whoGaveTheGift}</p>
                  <a
                    className="pointer text-primary"
                    href={`${PROJECT_BASENAME}regalos-recibidos/${item.id}/details`}
                  >
                    Ver detalle
                  </a>
                </div>
                <div className="text-center d-flex flex-column justify-content-center align-items-center">
                  <CurrencyFormat price={price} />
                </div>
              </div>

              <div className={`${styles.main} pb-4 text-center text-ellipsis`}>
                {congratulationMessage}
              </div>

              <div className={`${styles.footer} text-center`}>
                {![3, 5].includes(props.orderStatusId) || !props.hasEmail ? 
                    <td className="text-center">
                      <b>&nbsp;</b>
                    </td>
                  : showThanks && status === false ? (
                  <Button
                    variant="secondary"
                    className="text-uppercase"
                    onClick={onWelcomeClick}
                    {...props}
                  >
                    Agradecer
                  </Button>
                ) : (
                  <p className="font-weight-bold text-uppercase">
                    Agradecimiento no enviado
                  </p>
                )}
              </div>
            </div>
          ) : (
            <div className="py-5">
              <Cell {...props} column={column} item={item} />
            </div>
          )}
        </>
      );
    },
  },
];
